import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import QuickAddItem from './QuickAddItem';
import { QUESTION_TYPES } from '../utils/questionTypeStyles';

const QuickAddPanel = ({
  questions,
  isLoading,
  onQuickAdd,
  onReload
}) => {
  const [customPrompt, setCustomPrompt] = useState('');
  const [selectedType, setSelectedType] = useState('');

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-xs font-medium text-gray-700 mb-3">Quick Add</h3>
      
      <div className="space-y-3">
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className="w-full text-sm px-3 py-2 border rounded-md"
        >
          <option value="">Select question type</option>
          {Object.entries(QUESTION_TYPES).map(([value, { label }]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>

        <div>
          <input
            type="text"
            value={customPrompt}
            onChange={(e) => setCustomPrompt(e.target.value)}
            placeholder="Topic or skill (optional)"
            className="w-full text-sm px-3 py-2 border rounded-md"
          />
          <button
            onClick={() => {
              onReload(customPrompt, selectedType);
              setCustomPrompt('');
            }}
            disabled={isLoading}
            className={`w-full mt-2 flex items-center justify-center gap-1.5 px-3 py-1.5 text-sm 
              ${selectedType ? `${QUESTION_TYPES[selectedType].bg} ${QUESTION_TYPES[selectedType].text} ${QUESTION_TYPES[selectedType].hover}` : 
              'bg-blue-50 text-blue-600 hover:bg-blue-100'} rounded-md transition-colors`}
          >
            <RefreshCw className="h-3.5 w-3.5" />
            {isLoading ? 'Generating...' : 'Generate Questions'}
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center mt-4">
          <img src="/loader.gif" alt="Loading..." className="h-8 w-8" />
        </div>
      ) : questions.length > 0 ? (
        <div className="space-y-1 mt-4">
          {questions.map((question) => (
            <QuickAddItem 
              key={question.id}
              question={question}
              onClick={() => onQuickAdd(question)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default QuickAddPanel; 